import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getAutoRunAddinCommandsByEventType,
    addAutoRunAddinsToWaitingQueue,
    processAutoRunWaitingQueue,
    IAutoRunAddinCommand,
    IExtendedAddinCommand,
    IAddinCommandTelemetry,
} from 'owa-addins-store';
import LaunchEventType from 'owa-service/lib/contract/LaunchEventType';
import { ExtendedAddinCommand, AutoRunAddinCommandTelemetry } from 'owa-addins-schema';

/*
    1. Entry point to launch and execute autoRun Add-ins.
    2. Accepts hosteItemIndex and LaunchEventType as parameters
*/
let launchAutoRunAddins = (hostItemIndex: string, launchEventType: LaunchEventType) => {
    if (!isFeatureEnabled('addin-autoRun')) {
        return;
    }
    const autoRunAddinCommandList: IAutoRunAddinCommand[] = getAutoRunAddinCommandsByEventType(
        launchEventType
    ) as IAutoRunAddinCommand[];
    const extendedAddinCommandList = autoRunAddinCommandList.map(autoRunAddinCommand => {
        return new ExtendedAddinCommand(
            autoRunAddinCommand,
            new AutoRunAddinCommandTelemetry() as IAddinCommandTelemetry
        );
    }) as IExtendedAddinCommand[];

    addAutoRunAddinsToWaitingQueue(extendedAddinCommandList, hostItemIndex);
    processAutoRunWaitingQueue(hostItemIndex);
};

export default launchAutoRunAddins;
